import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CurrencyService } from 'src/app/util/currency.service';
import { UtilService } from 'src/app/util/util.service';
import {
  CLOSE_CIRCLE,
  EE_VALUE,
  EE_LOGO,
  EARNING_QR,
  EARNING_REC,
  EARNING_LOYALTY,
} from 'src/defaultImages.js';
import { LocalStorageService } from '../../services/localStorage.service';

@Component({
  selector: 'app-ee-value',
  templateUrl: './ee-value.component.html',
  styleUrls: ['./ee-value.component.css'],
})
export class EeValueComponent implements OnInit {
  images = {
    CLOSE_CIRCLE: CLOSE_CIRCLE,
    EE_VALUE: EE_VALUE,
    EE_LOGO: EE_LOGO,
    EARNING_QR: EARNING_QR,
    EARNING_REC: EARNING_REC,
    EARNING_LOYALTY: EARNING_LOYALTY,
  };
  Currency;
  analyticsData: any = [];
  grandEaring: number;
  translationText;
  eeValueData = [
    {
      img_url: this.images.EARNING_QR,
      title: 'Earnings by QR',
      description:
        'QR orders had higher average order value than POS orders',
      total_amount: 0,
      border_color: '#FF7555',
    },
    {
      img_url: this.images.EARNING_REC,
      title: 'Earnings by Recommendations',
      description:
        'Items added by customers through recommendations',
      total_amount: 0,
      border_color: '#29AB91',
    },
    {
      img_url: this.images.EARNING_LOYALTY,
      title: 'Earnings by Loyalty',
      description:
        'Total order value for which loyalty was redeemed',
      total_amount: 0,
      border_color: '#39A1EA',
    },
  ];
  subscription = new Subscription();
  constructor(
    public dialogRef: MatDialogRef<any>,
    private localStorage: LocalStorageService,
    private curr: CurrencyService,
    private translateService: TranslateService,
    private _util: UtilService
  ) {
    this.Currency = this.curr.getCurrency();
  }

  ngOnInit() {
    this.subscription.add(
      this.translateService.get(['EE_VALUE']).subscribe((res) => {
        this.translationText = res.EE_VALUE;
      })
    );
    this.analyticsData = this._util.getAnalyticsData();
    this.grandEaring = JSON.parse(this.localStorage.get('eeTotalEarnings'));
    let totalRecEarning = 0;
    let totalQrEarning = 0;
    let totalLoyaltyEarning = 0;
    if (
      this.analyticsData &&
      this.analyticsData.length > 0 &&
      this.analyticsData[0]
    ) {
      totalRecEarning = (this.analyticsData[0] || {}).value;
      totalQrEarning = (this.analyticsData[1] || {}).value;
      totalLoyaltyEarning = (this.analyticsData[2] || {}).value;
    }
    this.eeValueData = [
      {
        img_url: this.images.EARNING_QR,
        title: this.translationText.EARNING_BY_QR,
        description:
          this.translationText.QR_ORDER_VALUE_HIGHER_THAN_POS_ORDER,
        total_amount: totalQrEarning,
        border_color: '#FF7555',
      },
      {
        img_url: this.images.EARNING_REC,
        title: this.translationText.EARNING_BY_REC,
        description: this.translationText.ITEMS_ADDED_THROUGH_REC,
        total_amount: totalRecEarning,
        border_color: '#29AB91',
      },
      {
        img_url: this.images.EARNING_LOYALTY,
        title: this.translationText.EARNING_BY_LOYALTY,
        description: this.translationText.TOTAL_ORDER_VALUE_LOYALTY_REDEEMED,
        total_amount: totalLoyaltyEarning,
        border_color: '#39A1EA',
      },
    ];
  }

  cancel() {
    this.dialogRef.close({
      status: 0,
      data: null,
      message: 'closed',
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
	